export default "__VITE_ASSET__8913d275__"